import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Restringe el acceso a pantallas de administración a usuarios con rol
 * "Super Admin". Si no está autenticado → /signin; si está autenticado pero
 * no es Super Admin → ruta por defecto (contactos).
 */
export const superAdminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/signin']);
    return false;
  }

  if (authService.getCurrentUser()?.roleName === 'Super Admin') {
    return true;
  }

  router.navigate(['/contactos']);
  return false;
};
